import useTheme from '@mui/material/styles/useTheme';
import { MyClientsListProps } from './types';
import useMediaQuery from '@mui/material/useMediaQuery';
import MyClientListMobile from './MyClientListMobile';
import MyClientListDesktop from './MyClientListDesktop';

const MyClientLists = (props: MyClientsListProps) => {
  const theme = useTheme();
  const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return isSmScreen ? (
    <MyClientListMobile {...props} />
  ) : (
    <MyClientListDesktop {...props} />
  );
};

export default MyClientLists;
